import * as React from 'react';
import { StyledInstructions, StyledPageGuidanceInfoContainer } from './IntelligentPageGuidanceInfo.style';
export const IntelligentPageGuidanceInfo = ({ instructions }) => {
    return (React.createElement(StyledPageGuidanceInfoContainer, null,
        React.createElement(StyledInstructions, { dangerouslySetInnerHTML: { __html: instructions } })));
};
//# sourceMappingURL=IntelligentPageGuidanceInfo.js.map